import { State } from "@/stores/vehicle/type.ts";
export default {
  getVehicleListData: (state: State) => state.vehicleListResponse.results,
};
